<app-document-type-form
  [paymentDocumentType]="paymentDocumentType()"
  (onChange)="onDocumentTypeChange($event)"
/>

@if(paymentDocumentType() === 'invoice'){
<app-invoice-form #invoiceFormComponent />
}

<div class="field mb-4">
  <!-- Start::título -->
  <span class="text-900 text-2xl block font-semibold mb-5"
    >¿Cómo quieres pagar?</span
  >
  <!-- End::título -->

  <!-- Start::descripción -->
  <div
    class="p-4 mt-3 surface-100 flex align-items-center justify-content-between mb-4"
  >
    <span class="mr-3 md:mr-5 text-sm"
      >Los pagos se procesan con encriptación SSL para garantizar la seguridad
      de los datos de tu tarjeta y del pago.</span
    >
    <i class="fa-sharp-duotone fa-solid fa-shield-keyhole text-4xl"></i>
  </div>
  <!-- End::descripción -->

  <!-- Start::usuario bloqueado -->
  @if(customerBlocked){
  <div
    class="p-4 mt-3 surface-100 flex align-items-center justify-content-between mb-4 text-yellow-600 bg-yellow-50 border-yellow-100 border-1"
  >
    <div class="flex flex-column gap-1">
      <span class="font-semibold"
        >No es posible pagar con línea de crédito</span
      >
      <span class="text-sm"
        >Su línea de crédito ha sido bloqueada. Recargue la página para validar
        nuevamente su disponibilidad.</span
      >
    </div>

    <i class="fa-sharp-duotone fa-solid fa-triangle-exclamation text-4xl"></i>
  </div>
  }
  <!-- End::usuario bloqueado -->

  <!-- Start::formulario para seleccionar método de pago -->
  <form
    #paymentTypeFormElement
    [formGroup]="paymentTypeForm"
    (ngSubmit)="onPaymentMethodSubmit()"
  >
    <app-payment-method-form
      #paymentForm
      [payments]="payments"
      [isLoading]="isLoadingPayments()"
      formControlName="paymentType"
    />
  </form>
  <!-- End::formulario para seleccionar método de pago -->
</div>

<!-- Start::formulario para pagar con línea de crédito -->
@if(paymentTypeField?.value === 'ordenCompra'){
<app-purchase-order-form #purchaseOrderFormComponent />
}
<!-- End::formulario para pagar con línea de crédito -->

<!-- Start::formulario para aceptar términos y condiciones -->
@defer (when isLargeScreen() && isTermsOfServiceVisible){
<form
  [formGroup]="termsOfServiceForm"
  #termsOfServiceFormElement
  (ngSubmit)="onSubmitTermsOfServiceForm()"
  class="hidden lg:block"
>
  <app-terms-of-service-input formControlName="termsOfService" />
</form>
}
<!-- End::formulario para aceptar términos y condiciones -->
